import { DropdownItemProps } from "semantic-ui-react";
import * as moment from "moment";

import { Appointment } from "@teamprevent/common/calendar";

export interface CalendarDetails {
    entityId: string;
    appointments: Appointment[];
    workingDayStartTime: string;
    workingDayEndTime: string;
    workingDays: number[];
}

export interface EntityCalendars {
    [entityId: string]: Omit<CalendarDetails, "entityId">;
}

export interface CalendarFilters {
    userIds: string[];
    roomIds: string[];
}

export { ApplicationState } from "../applicationState";

export const emptyCalendarDetails: Omit<CalendarDetails, "entityId"> = {
    appointments: [] as Appointment[],
    workingDayStartTime: "00:00",
    workingDayEndTime: "23:59",
    workingDays: [0, 1, 2, 3, 4, 5, 6]
};

export enum ClinicTypeNames {
    BloodBorneVirus = "Blood Borne Virus",
    HealthSurveillance = "Health Surveillance",
    Immunisation = "Immunisation",
    Open = "Open",
    PhysiotherapyReferral = "Physiotherapy Referral",
    PPQ = "PPQ",
    Referral = "Referral"
}

export const ClinicTypesWithSlots: string[] = [
    ClinicTypeNames.BloodBorneVirus,
    ClinicTypeNames.Immunisation,
    ClinicTypeNames.PhysiotherapyReferral,
    ClinicTypeNames.PPQ,
    ClinicTypeNames.Referral
];

export const ClinicTypesWithoutSlots: string[] = [
    ClinicTypeNames.HealthSurveillance,
    ClinicTypeNames.Open
];

export const getDateOptionsForLocumUser = (isLocumUser?: boolean): DropdownItemProps[] => {
    const dateOptions: DropdownItemProps[] = [];

    if (isLocumUser) {
        const rangeStart = moment(moment.utc().subtract(5, "days"));
        const rangeEnd = moment(moment.utc().add(5, "days"));

        for (let currentDate = moment(rangeStart); currentDate.isSameOrBefore(rangeEnd); currentDate.add(1, "days")) {
            dateOptions.push(
                {
                    key: `${currentDate.format((moment as any).HTML5_FMT.DATE)}`,
                    text: `${currentDate.format("DD-MMM-yyyy")}`,
                    value: `${currentDate.format((moment as any).HTML5_FMT.DATE)}`
                });
        }
    }

    return dateOptions;
};
